import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ButtonLinkIconModule } from '@commons/pipes/button-link-icon/button-link-icon.pipe';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import { environment } from '@environment';
import { News } from '@models/news/news';
import { ImaginarySrcModule } from '@wizbii/angular-utilities';
import { EllipsisModule } from 'ngx-ellipsis';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-home-b-news-card',
  templateUrl: './news-card.component.html',
  styleUrls: ['./news-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsCardComponent {
  @Input() news!: News;

  get isMobile$(): Observable<boolean> {
    return this.breakpointsService.isMobile$;
  }

  get imageUrl(): string {
    return `${environment.api.googleStorage}/${environment.wizbiiFiles}/${this.news.image}`;
  }

  constructor(private readonly breakpointsService: BreakpointsService) {}
}

@NgModule({
  imports: [ButtonLinkIconModule, CommonModule, MatIconModule, EllipsisModule, MatButtonModule, ImaginarySrcModule],
  declarations: [NewsCardComponent],
  exports: [NewsCardComponent],
})
export class HomeBNewsCardModule {}
